import React from 'react';
import cn from 'classnames';
import { SuggestedProduct } from './components/suggested-product';
import css from './suggested-product-list.scss';
export const SuggestedProductListComponent = props => {
  const {
    suggestedProducts,
    listOfNearestVariants,
    onSuggestedProductClick,
    wrapperClassName = '',
    titleClassName = '',
    imageClassName = '',
    productImageWrapper = '',
    title = 'You might also like',
    isBlockHidden = false
  } = props;
  if (isBlockHidden) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cn(css.contentWrapper, wrapperClassName)
  }, /*#__PURE__*/React.createElement("h1", {
    className: cn(css.title, titleClassName)
  }, title), /*#__PURE__*/React.createElement("ul", {
    className: css.listWrapper
  }, suggestedProducts.map((suggestedProduct, key) => /*#__PURE__*/React.createElement("div", {
    className: css.listItem,
    key: key
  }, /*#__PURE__*/React.createElement(SuggestedProduct, {
    suggestedProduct: suggestedProduct,
    nearestVariant: listOfNearestVariants[suggestedProduct._id],
    productImageWrapper: productImageWrapper,
    imageClassName: imageClassName,
    onSuggestedProductClick: onSuggestedProductClick
  })))));
};